__turbopack_context__.v({
  "infoDiv": "YbO6Ca_infoDiv",
  "jobDetailPageMain": "YbO6Ca_jobDetailPageMain",
  "jobdetailhead": "YbO6Ca_jobdetailhead",
  "recentjobs": "YbO6Ca_recentjobs",
  "searchdiv": "YbO6Ca_searchdiv",
  "totalrecords": "YbO6Ca_totalrecords",
});
